import { render, staticRenderFns } from "./WidgetSegments.vue?vue&type=template&id=b0a00e9a&scoped=true&"
import script from "./WidgetSegments.vue?vue&type=script&lang=js&"
export * from "./WidgetSegments.vue?vue&type=script&lang=js&"
import style0 from "./WidgetSegments.vue?vue&type=style&index=0&id=b0a00e9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a00e9a",
  null
  
)

export default component.exports